import { MutationTree } from 'vuex'
import { SystemStateInterface } from './state'
import types from './types'

const mutation: MutationTree<SystemStateInterface> = {
  [types.SET_DISPLAY_CHOOSE_LANGUAGE_DIALOG_STATUS](state, status: boolean) {
    state.chooseLanguageDialog = {
      ...state.chooseLanguageDialog,
      status,
    }
  },
  [types.SET_LOCALE](state, language: string) {
    localStorage.setItem('locale', language)
  },
}

export default mutation
